import React from 'react';
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 w-full h-11 bg-urgency-red text-white z-50 overflow-hidden flex items-center shadow-md" data-id="element-245">
      <div className="whitespace-nowrap animate-marquee font-heading font-bold tracking-wide text-xs md:text-base" data-id="element-246">
        🔥 OFERTA DE LANZAMIENTO — 7 BONOS GRATIS HOY · Acceso inmediato ·
        Garantía 14 días 🔥 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 🔥 OFERTA DE
        LANZAMIENTO — 7 BONOS GRATIS HOY · Acceso inmediato · Garantía 14 días
        🔥 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 🔥 OFERTA DE LANZAMIENTO — 7
        BONOS GRATIS HOY · Acceso inmediato · Garantía 14 días 🔥
      </div>
    </div>;
}